import { useCallback } from "react"
import { Button, ButtonProps } from "@mezo-org/mezo-clay"

import { setOpenModal, useDappDispatch } from "#/redux-state"

export default function ConnectWalletButton({
  children,
  ...props
}: ButtonProps) {
  const dispatch = useDappDispatch()

  const connectWalletHandler = useCallback(() => {
    dispatch(setOpenModal("onboarding"))
  }, [dispatch])

  return (
    <Button size="large" onClick={connectWalletHandler} {...props}>
      {children}
    </Button>
  )
}
